export default "__VITE_ASSET__CN5xiBS7__"